var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupsBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_groups") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_groups"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,20.5 C13,20.775 12.775,21 12.5,21 L9.5,21 C9.225,21 9,20.775 9,20.5 L9,17.5 C9,17.225 9.225,17 9.5,17 L12.5,17 C12.775,17 13,17.225 13,17.5 L13,20.5 Z",
    id: "Path",
    stroke: "#004A99",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,20.5 C21,20.775 20.775,21 20.5,21 L17.5,21 C17.225,21 17,20.775 17,20.5 L17,17.5 C17,17.225 17.225,17 17.5,17 L20.5,17 C20.775,17 21,17.225 21,17.5 L21,20.5 Z",
    id: "Path",
    stroke: "#004A99",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,12.5 C13,12.775 12.775,13 12.5,13 L9.5,13 C9.225,13 9,12.775 9,12.5 L9,9.5 C9,9.225 9.225,9 9.5,9 L12.5,9 C12.775,9 13,9.225 13,9.5 L13,12.5 Z",
    id: "Path",
    stroke: "#004A99",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,12.5 C21,12.775 20.775,13 20.5,13 L17.5,13 C17.225,13 17,12.775 17,12.5 L17,9.5 C17,9.225 17.225,9 17.5,9 L20.5,9 C20.775,9 21,9.225 21,9.5 L21,12.5 Z",
    id: "Path",
    stroke: "#004A99",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupsBlue);
export default __webpack_public_path__ + "static/media/groups-blue.51fe87d652401304b6dea87c39b04aa4.svg";
export { ForwardRef as ReactComponent };